var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhone = function SvgPhone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 11,
    "data-width-16": 14,
    "data-width-20": 18,
    "data-width-24": 21,
    "data-width-28": 24,
    "data-width-72": 62,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.78 23.87h-.304A23.08 23.08 0 0 1 6.65 17.22 23.08 23.08 0 0 1 .012 3.395a3.1 3.1 0 0 1 .77-2.333A3.13 3.13 0 0 1 3.116 0h3.36a3.15 3.15 0 0 1 3.068 2.45l.77 3.827a3.08 3.08 0 0 1-.688 2.648l-.794.922a.27.27 0 0 0 0 .291 17 17 0 0 0 2.194 2.707 17.5 17.5 0 0 0 2.695 2.24.29.29 0 0 0 .315 0l.91-.793a3.12 3.12 0 0 1 2.648-.7l3.815.77a3.115 3.115 0 0 1 2.509 3.103v3.348a3.13 3.13 0 0 1-1.062 2.334 3.08 3.08 0 0 1-2.077.723M6.486 1.703h-3.36a1.38 1.38 0 0 0-1.026.479 1.17 1.17 0 0 0-.327.991A21.28 21.28 0 0 0 7.9 16.007a21.28 21.28 0 0 0 12.834 6.125 1.17 1.17 0 0 0 .991-.327 1.38 1.38 0 0 0 .479-1.027V17.43a1.365 1.365 0 0 0-1.097-1.365l-3.815-.77a1.37 1.37 0 0 0-1.167.303l-.933.805a2.006 2.006 0 0 1-2.427.152 21 21 0 0 1-2.963-2.438 20 20 0 0 1-2.509-2.987 2.01 2.01 0 0 1 .14-2.415l.805-.933a1.37 1.37 0 0 0 .315-1.167L7.83 2.8a1.365 1.365 0 0 0-1.342-1.097"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export default ForwardRef;